import * as actionType from "./galleryActionType";

const initialState = {
  isLoading: false,
  gallery: []
};

export const galleryReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.FETCH_GALLERY:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.FETCH_GALLERY_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.FETCH_GALLERY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                gallery: action.payload ? action.payload.data : [],
            };
        default:
            return state;
    }
}